import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../../data.service';
import { GeneralService } from '../../../../general.service';
import {TranslateService} from '@ngx-translate/core';
import { SSL_OP_NETSCAPE_CHALLENGE_BUG } from 'constants';
import { Subscription } from 'rxjs';

declare var decimalInput: any;

@Component({
  selector: 'app-matching',
  templateUrl: './matching.html',
  styleUrls: ['./matching.scss']
})

export class Matching implements OnInit {

  public showDecimalInput = false;
  public isTouchDevice = false;
  public isInTask = false;
  public matchResponses:string[] = [];
  public answers = [];

  private loadAnswersSubscription : Subscription;
  
  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService
  ) { 
    var exisitingLangauge = localStorage.getItem("userslanguage");
    if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
      this.dataSvc.changeLangauge(exisitingLangauge);
    }
    else{
      this.translate.setDefaultLang("en");
      this.translate.use("en");
    }

    this.loadAnswersSubscription = this.dataSvc.getLoadMatchingAnswersEvent().subscribe(()=>{
      this.loadAnswers();
    });
  }

  ngOnInit(): void {
    this.loadAnswers();
  }

  resetVariables(){
    this.matchResponses = [];
    this.answers = [];
  }
  loadAnswers() {
    this.resetVariables();
    if(this.dataSvc.currentQuestion().Question.QuestionType !== 8) return;

    //GETS THE MATCHING OPTIONS FROM THE QUESTIONS KEYWORDS FIELD AND ADDS TO ARRAY
    var keywords = this.dataSvc.currentQuestion().Question.Question.Keywords;
    if(keywords !== null && keywords !== undefined){
      var responses = keywords.split(";");
      for(var i = 0; i < responses.length; i++){
        this.matchResponses.push(responses[i]);
      }
      setTimeout(() => {
        this.loadSavedAnswers();
      },100);
    }    
  }

  loadSavedAnswers(){
    var savedAns = this.dataSvc.currentQuestion().Result.Selection;
    if(savedAns !== ""){
      this.answers = savedAns.split(",");
      for(var i = 0; i < this.answers.length; i++){
         var answer = this.answers[i].split("|");
         if(answer !== null && answer !== undefined){
           var element = <HTMLSelectElement>document.querySelectorAll("[name='" + (answer[1]) + "']")[0];
           if(element !== null && element !== undefined){
              element.value = answer[0];          
           }
        }
      } 
    }    
  }

  answerQuestion(value, answerId){
    var answer = value + "|" + answerId;
    var index = this.answers.findIndex(element => element.includes(answerId))
    if(index == -1)
    {
      this.answers.push(answer);
    }
    else{
      this.answers.splice(index, 1);
       this.answers.push(answer);
    }    
    this.dataSvc.currentQuestion().Result.Selection = this.answers.join(",");
  }

 
}
